"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _themeUi = require("theme-ui");

var _ButtonLink = _interopRequireDefault(require("../ButtonLink/ButtonLink"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _ToolTip = _interopRequireDefault(require("../ToolTip/ToolTip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CommentFooter = function CommentFooter(_ref) {
  var timeAgo = _ref.timeAgo,
      deleteDisabled = _ref.deleteDisabled,
      hideFooterCommands = _ref.hideFooterCommands,
      onClickEdit = _ref.onClickEdit,
      onClickDelete = _ref.onClickDelete,
      props = _objectWithoutPropertiesLoose(_ref, ["timeAgo", "deleteDisabled", "hideFooterCommands", "onClickEdit", "onClickDelete"]);

  return (0, _themeUi.jsx)(_themeUi.Flex, props, (0, _themeUi.jsx)(_Text["default"], {
    variant: "caption",
    sx: {
      color: 'textMediumEmphasis',
      ml: 2,
      mr: 3
    }
  }, timeAgo), hideFooterCommands ? null : (0, _themeUi.jsx)(_react.Fragment, null, onClickEdit && (0, _themeUi.jsx)(_ButtonLink["default"], {
    variant: "caption",
    sx: {
      color: 'textMediumEmphasis',
      mr: 2
    },
    onClick: onClickEdit
  }, "Edit"), onClickDelete && (0, _themeUi.jsx)(_react.Fragment, null, deleteDisabled ? (0, _themeUi.jsx)(_ToolTip["default"], {
    text: "Sorry, you cannot delete a comment that your collaborators have liked."
  }, (0, _themeUi.jsx)(_ButtonLink["default"], {
    variant: "caption",
    sx: {
      pointerEvents: 'none',
      display: 'block'
    },
    disabled: true
  }, "Delete")) : (0, _themeUi.jsx)(_ButtonLink["default"], {
    variant: "caption",
    sx: {
      ml: 2
    },
    onClick: onClickDelete
  }, "Delete"))));
};

CommentFooter.propTypes = {
  timeAgo: _propTypes["default"].string,
  deleteDisabled: _propTypes["default"].number,
  hideFooterCommands: _propTypes["default"].bool,
  onClickEdit: _propTypes["default"].func,
  onClickDelete: _propTypes["default"].func
};
CommentFooter.defaultProps = {
  deleteDisabled: false,
  hideFooterCommands: false
};
var _default = CommentFooter;
exports["default"] = _default;